import { LANDING } from 'constants/testIds';

const DISCIPLINES = [
  'Photographers',
  'Videographers',
  'Editors',
  'Models',
  'Stylists',
  'HMUAs',
  'Social Media Managers',
  'Directors',
  'Designers',
  'Illustrators',
  'Producers',
  'Art Directors',
];

// Duplicate the list to enable seamless infinite loop
const TRACK = [...DISCIPLINES, ...DISCIPLINES];

export const Marquee = () => {
  return (
    <section
      data-testid={LANDING.marqueeSection}
      aria-label="Creative disciplines"
      className="relative py-12 md:py-16 border-y border-zinc-900 overflow-hidden bg-zinc-950"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-zinc-950 to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-zinc-950 to-transparent z-10" />

      <div className="flex overflow-hidden">
        <div className="marquee-track flex shrink-0 items-center gap-16 pr-16">
          {TRACK.map((d, i) => (
            <div key={`${d}-${i}`} className="flex items-center gap-16 shrink-0">
              <span className="font-display text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-zinc-400 whitespace-nowrap">
                {d}
              </span>
              <span className="h-2 w-2 rounded-full bg-[#6C63F5] shrink-0" aria-hidden />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
